module.exports = __webpack_public_path__ + "img/service02.29ba5416.png";